function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.88721 0.428162C1.78721 0.428162 0.887207 1.31746 0.887207 2.40438C0.887207 3.49131 1.78721 4.38061 2.88721 4.38061C3.98721 4.38061 4.88721 3.49131 4.88721 2.40438C4.88721 1.31746 3.98721 0.428162 2.88721 0.428162ZM14.8872 0.428162C13.7872 0.428162 12.8872 1.31746 12.8872 2.40438C12.8872 3.49131 13.7872 4.38061 14.8872 4.38061C15.9872 4.38061 16.8872 3.49131 16.8872 2.40438C16.8872 1.31746 15.9872 0.428162 14.8872 0.428162ZM6.88721 2.40438C6.88721 1.31746 7.78721 0.428162 8.88721 0.428162C9.98721 0.428162 10.8872 1.31746 10.8872 2.40438C10.8872 3.49131 9.98721 4.38061 8.88721 4.38061C7.78721 4.38061 6.88721 3.49131 6.88721 2.40438Z",
  fill: "#1C73FF"
});
const SvgEllipsis = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 17,
    height: 5,
    viewBox: "0 0 17 5",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEllipsis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ellipsis.f33d2e11.svg";
export { ForwardRef as ReactComponent };